(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aud-edge-home"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('aud-quick-practice')){
 customElements.define('aud-quick-practice',class extends HTMLElement{
  connectedCallback(){
   if(this.ready)return;this.ready=true;
   const questions=Array.from(this.querySelectorAll('[data-quick-question]'));
   if(!questions.length)return;
   let answers=[],score=0;
   const storageKey='aud-edge-quick-practice:v1';
   const position=this.querySelector('[data-quick-position]');
   const reset=this.querySelector('[data-quick-reset]');
   const complete=this.querySelector('[data-quick-complete]');
   const show=(i,focus=true)=>{questions.forEach((q,n)=>q.hidden=n!==i);position.textContent=`${this.dataset.question} ${i+1} ${this.dataset.of} ${questions.length}`;if(focus)questions[i].querySelector('input').focus();};
   questions.forEach((q,i)=>{
    const check=q.querySelector('[data-quick-check]'),next=q.querySelector('[data-quick-next]'),feedback=q.querySelector('[data-quick-feedback]');
    check.addEventListener('click',()=>{
     if(q.dataset.answered==='true')return;
     const selected=q.querySelector('input:checked');
     if(!selected){feedback.textContent=this.dataset.choose;q.querySelector('input').focus();return;}
     q.dataset.answered='true';const correct=selected.value===q.dataset.correct;
     if(correct)score++;
     answers.push({id:q.dataset.questionId,answer:selected.value,signature:q.dataset.practiceSignature});
     feedback.textContent=correct?this.dataset.correct:this.dataset.incorrect;
     q.querySelectorAll('input').forEach(input=>{input.disabled=true;if(input.value===q.dataset.correct)input.closest('label').classList.add('is-correct');});
     if(!correct)selected.closest('label').classList.add('is-incorrect');
     this.querySelector('[data-quick-score]').textContent=String(score);
     q.querySelector('[data-quick-explanation]').hidden=false;check.hidden=true;reset.hidden=false;
     if(next){next.hidden=false;next.focus();}else{complete.hidden=false;this.querySelector('[data-quick-final]').textContent=String(score);this.querySelector('[data-quick-continue]').focus();}
    });
    next?.addEventListener('click',()=>{if(q.dataset.answered==='true')show(i+1);});
   });
   const continueLink=this.querySelector('[data-quick-continue]');
   continueLink.addEventListener('click',()=>{continueLink.hash=answers.length?'continue-practice':'';try{if(answers.length)sessionStorage.setItem(storageKey,JSON.stringify({created:Date.now(),answers}));else sessionStorage.removeItem(storageKey);}catch{}});
   reset.addEventListener('click',()=>{
    score=0;answers=[];complete.hidden=true;reset.hidden=true;this.querySelector('[data-quick-score]').textContent='0';
    questions.forEach(q=>{q.dataset.answered='false';q.querySelectorAll('input').forEach(input=>{input.disabled=false;input.checked=false;input.closest('label').classList.remove('is-correct','is-incorrect');});q.querySelector('[data-quick-feedback]').textContent='';q.querySelector('[data-quick-explanation]').hidden=true;q.querySelector('[data-quick-check]').hidden=false;const next=q.querySelector('[data-quick-next]');if(next)next.hidden=true;});
    try{sessionStorage.removeItem(storageKey);}catch{}show(0);
   });
   show(0,false);
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aud-edge-preview"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeDemo = (demo) => {
      if (!demo || demo.dataset.ready === 'true') return;
      demo.dataset.ready = 'true';

      const questions = Array.from(demo.querySelectorAll('[data-demo-question]'));
      if (!questions.length) return;

      const progress = demo.querySelector('[data-demo-progress]');
      const progressBar = demo.querySelector('[data-demo-progressbar]');
      const progressFill = demo.querySelector('[data-demo-progressfill]');
      const position = demo.querySelector('[data-demo-position]');
      const goalProgressBar = demo.querySelector('[data-demo-goal-progressbar]');
      const goalProgressFill = demo.querySelector('[data-demo-goal-progressfill]');
      const answeredOutputs = demo.querySelectorAll('[data-demo-answered]');
      const accuracyOutputs = demo.querySelectorAll('[data-demo-accuracy]');
      const liveScoreOutputs = demo.querySelectorAll('[data-demo-live-score]');
      const focusOutputs = demo.querySelectorAll('[data-demo-focus]');
      const focusDetail = demo.querySelector('[data-demo-focus-detail]');
      const remainingOutput = demo.querySelector('[data-demo-remaining]');
      const complete = demo.querySelector('[data-demo-complete]');
      const scoreOutput = demo.querySelector('[data-demo-score]');
      const finalAccuracy = demo.querySelector('[data-demo-final-accuracy]');
      const finalFocus = demo.querySelector('[data-demo-final-focus]');
      const performanceMap = demo.querySelector('[data-demo-performance-map]');
      const restart = demo.querySelector('[data-demo-restart]');
      const areaResults = new Map();
      let score = 0;
      let answered = 0;
      let importingPreview = false;
      const carryoverNotice = demo.querySelector('[data-demo-carryover]');

      questions.forEach((question) => {
        const area = question.dataset.focusArea || 'Mixed practice';
        if (!areaResults.has(area)) {
          areaResults.set(area, { attempted: 0, correct: 0 });
        }
      });

      const setText = (nodes, value) => {
        nodes.forEach((node) => {
          node.textContent = value;
        });
      };

      const getFocusArea = () => {
        return Array.from(areaResults.entries())
          .map(([name, result]) => ({
            name,
            attempted: result.attempted,
            correct: result.correct,
            missed: result.attempted - result.correct,
            accuracy: result.attempted ? result.correct / result.attempted : 1
          }))
          .filter((result) => result.missed > 0)
          .sort((first, second) => {
            return first.accuracy - second.accuracy || second.missed - first.missed || first.name.localeCompare(second.name);
          })[0] || null;
      };

      const updateDashboard = () => {
        const total = questions.length;
        const accuracy = answered ? Math.round((score / answered) * 100) : null;
        const focusArea = getFocusArea();
        const focusName = focusArea ? focusArea.name : demo.dataset.focusEmptyLabel;

        setText(answeredOutputs, String(answered));
        setText(liveScoreOutputs, String(score));
        setText(accuracyOutputs, accuracy === null ? '—' : `${accuracy}%`);
        setText(focusOutputs, focusName);
        remainingOutput.textContent = String(Math.max(total - answered, 0));
        goalProgressBar.setAttribute('aria-valuenow', String(answered));
        goalProgressFill.style.width = `${(answered / total) * 100}%`;
        focusDetail.textContent = focusArea ? demo.dataset.focusMissDetail : demo.dataset.focusEmptyDetail;
        finalAccuracy.textContent = accuracy === null ? '0%' : `${accuracy}%`;
        finalFocus.textContent = focusName;
      };

      const renderPerformanceMap = () => {
        const focusArea = getFocusArea();
        performanceMap.replaceChildren();

        areaResults.forEach((result, name) => {
          const accuracy = result.attempted ? Math.round((result.correct / result.attempted) * 100) : 0;
          const row = document.createElement('div');
          const heading = document.createElement('div');
          const label = document.createElement('span');
          const resultText = document.createElement('strong');
          const bar = document.createElement('div');
          const fill = document.createElement('span');

          row.className = 'aud-edge-demo__performance-row';
          if (focusArea && focusArea.name === name) row.classList.add('is-focus');
          label.textContent = name;
          resultText.textContent = `${result.correct}/${result.attempted} · ${accuracy}%`;
          bar.className = 'aud-edge-demo__performance-bar';
          fill.style.width = `${accuracy}%`;
          bar.setAttribute('role', 'progressbar');
          bar.setAttribute('aria-label', name);
          bar.setAttribute('aria-valuemin', '0');
          bar.setAttribute('aria-valuemax', '100');
          bar.setAttribute('aria-valuenow', String(accuracy));
          heading.append(label, resultText);
          bar.append(fill);
          row.append(heading, bar);
          performanceMap.append(row);
        });
      };

      const showQuestion = (index, focus = true) => {
        questions.forEach((question, questionIndex) => {
          question.hidden = questionIndex !== index;
        });
        const total = questions.length;
        const questionNumber = index + 1;
        position.textContent = `${demo.dataset.questionLabel} ${questionNumber} ${demo.dataset.ofLabel} ${total}`;
        progressBar.setAttribute('aria-valuenow', String(questionNumber));
        progressFill.style.width = `${(questionNumber / total) * 100}%`;
        if (focus) questions[index].querySelector('input')?.focus();
      };

      questions.forEach((question, questionIndex) => {
        const check = question.querySelector('[data-demo-check]');
        const next = question.querySelector('[data-demo-next]');
        const feedback = question.querySelector('[data-demo-feedback]');
        const explanation = question.querySelector('[data-demo-explanation]');

        check.addEventListener('click', () => {
          if (question.dataset.answered === 'true') return;
          const selected = question.querySelector('input[type="radio"]:checked');

          if (!selected) {
            feedback.textContent = demo.dataset.chooseLabel;
            feedback.className = 'aud-edge-demo__feedback is-incorrect';
            return;
          }

          question.dataset.answered = 'true';
          const isCorrect = selected.value === question.dataset.correct;
          const correctInput = question.querySelector(`input[value="${question.dataset.correct}"]`);
          const area = question.dataset.focusArea || 'Mixed practice';
          const areaResult = areaResults.get(area);

          if (isCorrect) {
            score += 1;
            areaResult.correct += 1;
            feedback.textContent = demo.dataset.correctLabel;
            feedback.className = 'aud-edge-demo__feedback is-correct';
          } else {
            selected.closest('label')?.classList.add('is-incorrect');
            feedback.textContent = demo.dataset.incorrectLabel;
            feedback.className = 'aud-edge-demo__feedback is-incorrect';
          }

          answered += 1;
          areaResult.attempted += 1;
          updateDashboard();

          correctInput?.closest('label')?.classList.add('is-correct');
          question.querySelectorAll('input').forEach((input) => {
            input.disabled = true;
          });
          explanation.hidden = false;
          check.hidden = true;
          next.hidden = false;
          if (!importingPreview) next.focus();
        });

        next.addEventListener('click', () => {
          if (questionIndex < questions.length - 1) {
            showQuestion(questionIndex + 1);
            return;
          }

          questions.forEach((item) => {
            item.hidden = true;
          });
          progress.hidden = true;
          scoreOutput.textContent = String(score);
          renderPerformanceMap();
          complete.hidden = false;
          complete.querySelector('a, button')?.focus();
        });
      });

      restart.addEventListener('click', () => {
        carryoverNotice.hidden = true;
        score = 0;
        answered = 0;
        complete.hidden = true;
        progress.hidden = false;

        areaResults.forEach((result) => {
          result.attempted = 0;
          result.correct = 0;
        });
        performanceMap.replaceChildren();

        questions.forEach((question) => {
          question.dataset.answered = 'false';
          question.querySelectorAll('input').forEach((input) => {
            input.checked = false;
            input.disabled = false;
            input.closest('label')?.classList.remove('is-correct', 'is-incorrect');
          });
          const feedback = question.querySelector('[data-demo-feedback]');
          feedback.textContent = '';
          feedback.className = 'aud-edge-demo__feedback';
          question.querySelector('[data-demo-explanation]').hidden = true;
          question.querySelector('[data-demo-check]').hidden = false;
          question.querySelector('[data-demo-next]').hidden = true;
        });

        updateDashboard();
        showQuestion(0);
      });

      let resumedCount = 0;
      if (window.location.hash === '#continue-practice') {
        try {
          const saved = JSON.parse(sessionStorage.getItem('aud-edge-quick-practice:v1') || 'null');
          sessionStorage.removeItem('aud-edge-quick-practice:v1');
          const valid = saved && Number.isFinite(saved.created) && Date.now() >= saved.created && Date.now()-saved.created < 30*60*1000 && Array.isArray(saved.answers) && saved.answers.length > 0 && saved.answers.length <= 3 && saved.answers.length < questions.length && saved.answers.every((answer,i) => answer && questions[i].dataset.questionId === answer.id && questions[i].dataset.practiceSignature === answer.signature && ['a','b','c','d'].includes(answer.answer));
          if (valid) {
            importingPreview = true;
            saved.answers.forEach((answer,i) => {const q=questions[i];q.querySelector(`input[value="${answer.answer}"]`).checked=true;q.querySelector('[data-demo-check]').click();});
            importingPreview = false;
            resumedCount = saved.answers.length;
          }
        } catch { importingPreview = false; }
        carryoverNotice.textContent = resumedCount ? carryoverNotice.dataset.resumed : carryoverNotice.dataset.fresh;
        carryoverNotice.hidden = false;
        history.replaceState(null, '', window.location.pathname + window.location.search);
      }
      updateDashboard();
      showQuestion(resumedCount, false);
    };

    document.querySelectorAll('[data-aud-edge-demo]').forEach(initializeDemo);
    document.addEventListener('shopify:section:load', (event) => {
      initializeDemo(event.target.querySelector('[data-aud-edge-demo]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aud-practice-preview"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('aud-home-sample')) {
  customElements.define('aud-home-sample', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const check = this.querySelector('[data-sample-check]');
      const reset = this.querySelector('[data-sample-reset]');
      const feedback = this.querySelector('[data-sample-feedback]');
      const rationale = this.querySelector('[data-sample-rationale]');
      check.addEventListener('click', () => {
        if (this.answered) return;
        const selected = this.querySelector('input:checked');
        if (!selected) { feedback.textContent = this.dataset.chooseMessage; this.querySelector('input').focus(); return; }
        const correct = selected.value === this.dataset.correct;
        this.answered = true;
        this.querySelector('[data-sample-answered]').textContent = '1/1';
        this.querySelector('[data-sample-accuracy]').textContent = correct ? '100%' : '0%';
        this.querySelector('[data-sample-score]').textContent = correct ? '1/1' : '0/1';
        feedback.textContent = correct ? this.dataset.correctMessage : this.dataset.incorrectMessage;
        this.querySelectorAll('input').forEach(input => { input.disabled = true; if (input.value === this.dataset.correct) input.closest('label').classList.add('is-correct'); });
        if (!correct) selected.closest('label').classList.add('is-incorrect');
        rationale.hidden = false; rationale.open = true; reset.hidden = false; check.disabled = true;
      });
      reset.addEventListener('click', () => {
        this.answered = false;
        this.querySelectorAll('input').forEach(input => { input.disabled = false; input.checked = false; input.closest('label').classList.remove('is-correct', 'is-incorrect'); });
        this.querySelector('[data-sample-answered]').textContent = '0/1';
        this.querySelector('[data-sample-accuracy]').textContent = '—';
        this.querySelector('[data-sample-score]').textContent = '0/1';
        feedback.textContent = ''; rationale.hidden = true; rationale.open = false; reset.hidden = true; check.disabled = false; this.querySelector('input').focus();
      });
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
